<template>
  <BBPModalWindow>
    <div class="bbp-modal-delete" @click.stop v-click-outside="closeModal">
      <i class="bbp-icon-cross bbp-modal-delete__close" @click="closeModal"/>
      <transition name="bbp-slide-fade">
        <span v-if="!deleteConfirm.stepTwo">Step 1</span>
      </transition>
      <transition name="bbp-slide-fade">
        <span v-if="deleteConfirm.stepTwo">Step 2</span>
      </transition>
      <p class="bbp-modal-delete__number" v-if="title">
        {{title}}
      </p>
      <p class="bbp-modal-delete__text">
        Please enter DELETE
        <transition name="bounce">
          <span v-if="deleteConfirm.stepTwo">again</span>
        </transition>
        to confirm deletion
      </p>
      <div>
        <input class="bbp-input bbp-input_border bbp-modal-delete__input"
               v-model="inputText"
               @keyup.esc="closeModal"
               @keyup.enter="checkConfirmDelete()"
               :class="{
                   'bbp-modal-delete__input_error': inputError}"
               v-autofocus/>
      </div>
      <button class="bbp-modal-delete__button bbp-button" @click="checkConfirmDelete()">DELETE</button>
    </div>
  </BBPModalWindow>
</template>

<script>
import BBPModalWindow from '@/components/Main/BBPModalWindow/BBPModalWindow'

export default {
  name: 'DoubleDelete',
  props: ['id', 'title', 'open'],
  components: {
    BBPModalWindow
  },
  data () {
    return {
      inputText: '',
      inputError: false,
      deleteConfirm: {
        item: {},
        stepTwo: false
      }
    }
  },
  methods: {
    closeModal () {
      this.deleteConfirm.stepTwo = false
      this.$emit('close')
    },
    checkConfirmDelete () {
      if (this.deleteConfirm.stepTwo && this.inputText === 'DELETE') {
        this.inputText = ''
        this.inputError = false
        this.$emit('delete', this.id)
        return
      } else {
        this.inputError = true
        setTimeout(() => {
          this.inputError = false
        }, 2000)
      }
      if (this.inputText === 'DELETE') {
        this.deleteConfirm.stepTwo = true
        this.inputError = false
      } else {
        this.inputError = true
      }
      this.inputText = ''
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../sass/variables";
  @import "../../../sass/mixins";

  .bbp-modal-delete {
    @include global-font;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    font-size: 14px;
    background-color: $color-white;
    border-radius: 8px;
    padding: 30px;
    color: $color-black;

    &__close {
      position: absolute;
      top: 8px;
      right: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: $color-silver;
      width: 26px;
      height: 26px;
      transition: 0.3s;
      cursor: pointer;

      &:hover {
        color: $color-dusty-gray
      }
    }

    &__number {
      margin: 15px auto;
      font-weight: bold;
    }

    &__text {
      margin-bottom: 25px;
    }

    &__input {
      &_error {
        animation: shake .3s ease-out;
        border-color: $color-pomegranate;
      }
    }

    &__button {
      margin-top: 25px;
      width: 117px;
      box-sizing: border-box;
      border: 2px solid rgba($color-pomegranate, 1);
      position: relative;
      margin-left: 16px;
      color: $color-pomegranate;
      background-color: $color-white;

      &:hover {
        background-color: $color-white;
        border-color: rgba($color-pomegranate, 0.65);
      }
    }
  }

  @keyframes shake {
    from,
    to {
      transform: translate3d(0, 0, 0);
    }

    20%,
    60% {
      transform: translate3d(-3px, 0, 0);
    }

    40%,
    80% {
      transform: translate3d(3px, 0, 0);
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Main/BBPDoubleDelete/BBPDoubleDelete.vue